import * as yup from "yup";
import {string} from "yup";
import i18n from "i18next";
import {StringToLowerCaseFirst} from "../../../Common/Helpers/StringToLowerCaseFirst";
import {ChangeDateFormat} from "../../../Common/Helpers/ChangeDateFormat";
class RequestAdditionalInfo {
    constructor({
                    accountingId = '',
                    accountingName = '',
                    additionalInfo = {},
                    additionalFileExtension = '',
                    additionalFileName = '',
                } = {}) {
        this.accountingId = accountingId;
        this.accountingName = accountingName;
        this.additionalInfo = additionalInfo;
        this.additionalFileExtension = additionalFileExtension;
        this.additionalFileName = additionalFileName;
    }

    static getAttributes(filter = null, validationSchema = null ,optionsData = null, customField = null) {
        const date = i18n.t('modelLabel.date');
        const purpose = i18n.t('reimbursement.purpose');
        const fileIdPlaceholder = i18n.t('formPlaceholder.dragAndDrop');
        const greaterO = i18n.t('validationMessage.greater0');
        const required = i18n.t('validationMessage.fieldRequired');

        let optionsAccounting = [];
        if (optionsData) {
            optionsData.accounting.map(item => {
                if (item.name !== "Övriga externa kostnader, avdragsgilla") {
                    optionsAccounting.push({
                        label: item.showLabel ?? item.name,
                        value: item.id
                    });
                }
            });
            const otherPosition = optionsData.accounting.findIndex(item => item.name === "Övriga externa kostnader, avdragsgilla");
            if (otherPosition !== -1) {
                optionsAccounting.push({
                    label: optionsData.accounting[otherPosition].showLabel ?? optionsData.accounting[otherPosition].name,
                    value: optionsData.accounting[otherPosition].id
                });
            }
        }

        let customAttribute = null;
        let attributeName = null;

        if (customField) {
            customAttribute = {
                'label': customField.label,
                'form': {
                    'type': StringToLowerCaseFirst(customField.inputType),
                    'placeholder': customField.inputType === 'File' ? fileIdPlaceholder : '',
                    'buttonView': false,
                },
                'id': StringToLowerCaseFirst(customField.requestName),
            };
            if (customField.inputType === "Textarea") {
                customAttribute.form.rows = 5;
            }
            attributeName = StringToLowerCaseFirst(customField.requestName);
        }

        const completeSchema = yup.object().shape({
            id: string().nullable(),
            fileId: string().required(required).nullable().test("is-required", `${required}`, value => {
                return value !== "";
            }),
        });

        const attributes = {
            id :{
                'label': "Id",
                'form': {
                    'type': 'text',
                    'validation': completeSchema.fields.id,
                },
                'value': (item) => item.id || "",
            },            
            fileId :{
                'label': i18n.t('reimbursement.addReceipts'),
                'form': {
                    'type':'file',
                    'placeholder': fileIdPlaceholder,
                    'buttonView': false,
                    'validation': completeSchema.fields.fileId,
                },
                'value': (item) => item.fileId || "",
            },
            dateReceive :{
                'label': i18n.t('modelLabel.dateReceive'),
                'form': {
                    'type': 'date',
                    'placeholder': i18n.t('formPlaceholder.enterDate'),
                    'validation': completeSchema.fields.dateReceive,
                    "maxDate": new Date(),
                },
                'value': (item) => item.dateReceive  ? ChangeDateFormat('date', item.dateReceive) : "",
            },
        }

        if (customField && customAttribute && attributeName) {
            attributes[attributeName] = customAttribute;
        }
        if (validationSchema === true) {
            return completeSchema;
        }

        return attributes;
    }
}
export default RequestAdditionalInfo;